// extracted by mini-css-extract-plugin
export default {"container":"AccountLanguage--container--4baeb4","icon":"AccountLanguage--icon--e4c8b0","label":"AccountLanguage--label--7068f5"};